import { Footer } from "@/components/LandingPage/Footer";
import Navbar from "@/components/LandingPage/Navbar";
import { Box, Flex, Heading, Stack } from "@chakra-ui/react";
import Head from "next/head";
import featuresRectangle from "@root/public/landing/features-rectangle.svg";
import Image from "next/image";
import { useTranslations } from "next-intl";
import { state } from "@/state";
import { useRouter } from "next/router";
import { useEffect } from "react";
import type { Metadata } from "next";
import { prisma } from "@/server/prisma";
import { TestimonialsSection } from "@/components/LandingPage/TestimonialsSection";
import { GetStarted } from "@/components/LandingPage/GetStarted";
import heroBg from "@root/public/images/photos/clarifayo_montanha.jpg";
export const metadata: Metadata = {
  title: "Clarifayo",
  description: "Code of Conduct",
};

const Hero = () => {
  const t = useTranslations();

  return (
    <Stack
      gap={{ base: 8, md: 14 }}
      py={{ base: 32, md: 20 }}
      px={{
        base: 8,
        md: 20,
      }}
      bgColor="brand.1000"
      minH={{
        base: "90vh",
      }}
      position="relative"
      overflow={"hidden"}
      backgroundImage={`url(${heroBg.src})`}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundAttachment="fixed"
    >
      <Box className="hero-bg"></Box>
      <Box position="absolute" top={0} left={0} w="full">
        <Navbar />
      </Box>
      <Box className="flex-1"></Box>
      <Stack
        as={Box}
        direction={["column", "row"]}
        textAlign={"left"}
        alignItems="center"
        flex={1}
        gap={{
          base: 8,
          md: 4,
        }}
        position="relative"
        h="full"
      >
        <Image
          src={featuresRectangle}
          alt="Rectangles"
          style={{
            position: "absolute",
            left: "-40px",
            bottom: "-100px",
            zIndex: -0,
            objectFit: "cover",
          }}
        />
        <Box flex={2} zIndex={1}>
          <Heading
            color={"brand.100"}
            fontFamily={"Gotham"}
            letterSpacing={"1"}
            fontWeight={600}
            fontSize={{ base: "3xl", sm: "4xl", md: "5xl" }}
            lineHeight={"110%"}
            textAlign={{ base: "center", md: "left" }}
          >
            {t("codeOfConduct")}
          </Heading>
        </Box>
        <Box flex={3} textAlign={"center"} h="full" zIndex={1}>
          <Heading
            color="white"
            fontSize={{ base: "3xl", sm: "4xl", md: "5xl" }}
            lineHeight={"110%"}
            textAlign={"center"}
          >
            Clarifayo
          </Heading>
        </Box>
      </Stack>
    </Stack>
  );
};

const ContentViewer = (props: any) => {
  return (
    <Flex w="full" flexDirection={"column"} gap={4}>
      <div
        id="code-of-conduct"
        dangerouslySetInnerHTML={{
          __html: props.content?.value?.replace(
            /<style[^>]*>.*?<\/style>/gs,
            ""
          ) ?? "",
        }}
      ></div>
    </Flex>
  );
};

const keys = {
  codeOfConduct: "CODE_OF_CONDUCT",
};

const Content = (props: any) => {
  const router = useRouter();

  useEffect(() => {
    const userLang = router.pathname.includes("/en/") ? "en" : "pt";
    state.lang = userLang;
  }, [router]);

  return (
    <>
      <Stack
        py={{ base: 20, md: 20 }}
        px={{
          base: 8,
          md: 20,
        }}
        bgColor="brand.100"
      >
        <ContentViewer content={props.content} />
      </Stack>
    </>
  );
};

export default function Page(props: any) {
  return (
    <>
      <Head>
        <title>Clarifayo - maximize your Coaching Activity</title>
      </Head>
      <Box bgColor="brand.100">
        <Hero />
        <Content content={props.content} />
        <TestimonialsSection />
        <GetStarted />
        <Footer />
      </Box>
    </>
  );
}

export async function getServerSideProps() {
  const content = await prisma.appContent.findFirst({
    where: {
      key: keys.codeOfConduct as any,
    },
    select: {
      id: true,
      key: true,
      value: true,
    },
  });
  return {
    props: {
      content: content ?? {},
    },
  };
}
